import { render, staticRenderFns } from "./PortalSelectField.vue?vue&type=template&id=30c2496c&scoped=true&"
import script from "./PortalSelectField.vue?vue&type=script&lang=js&"
export * from "./PortalSelectField.vue?vue&type=script&lang=js&"
import style0 from "./PortalSelectField.vue?vue&type=style&index=0&id=30c2496c&scoped=true&lang=scss&"
import style1 from "./PortalSelectField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2496c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
